import { API_URL } from './env'

export const urlFiles = {
  productImage: `${API_URL}/foto-producto`,
  productFile: `${API_URL}/archivo-producto`,
  userProfile: `${API_URL}/perfil-usuario`,
}

export const urlPdfs = {
  // pdfs a4  
  ventaA4: `${API_URL}/api/pdf/a4/venta`,
  ventaA4Half: `${API_URL}/api/pdf/a4-half/venta`,
  notaCreditoA4: `${API_URL}/api/pdf/a4/nota-credito`,
  proformaA4: `${API_URL}/api/pdf/a4/proforma`,
  pedidoA4: `${API_URL}/api/pdf/a4/pedido`,
  ordenCompraA4: `${API_URL}/api/pdf/a4/orden-compra`,
  guiaA4: `${API_URL}/api/pdf/a4/guia-remision`,
  entradaA4: `${API_URL}/api/pdf/a4/entrada`,
  salidaA4: `${API_URL}/api/pdf/a4/salida`,
  trasladoA4: `${API_URL}/api/pdf/a4/traslado`,
  cierreCajaA4: `${API_URL}/api/pdf/a4/cierre-caja`,
  liquidationPdf: `${API_URL}/api/cash-registers`,
  ordenServicioA4: `${API_URL}/api/pdf/a4/orden-servicio`,
  reclamacionA4: `${API_URL}/api/pdf/a4/reclamacion`,
  inventarioOrdenServicioA4: `${API_URL}/api/pdf/a4/inventario-orden-servicio`,
  reportePrestamosClienteA4: `${API_URL}/api/pdf/a4/reporte-prestamos-cliente`,
  listaPreciosPorAtributosA4: `${API_URL}/api/pdf/a4/price-list-by`,
  reporteContableVentasA4: `${API_URL}/api/pdf/a4/accounting-sales-report`,
  reporteContableNotasCreditoA4: `${API_URL}/api/pdf/a4/accounting-credit-notes-report`,
  reporteTop10Clientes: `${API_URL}/api/reports/top-10-clients`,
  reporteProductosPorMarca: `${API_URL}/api/reports/products-by-brand`,
  reporteComprasPorMarca: `${API_URL}/api/reports/purchases-by-brand`,
  reporteVentasPorTipoComprobante: `${API_URL}/api/reports/sales-by-voucher-type`,

  // pdfs ticket
  anticipoVentaTicket: `${API_URL}/api/pdf/ticket/anticipo-venta`,
  ventaTicket: `${API_URL}/api/pdf/ticket/venta`,
  ventaTickets: `${API_URL}/api/pdf/ticket/venta-tickets`,
  proformaTicket: `${API_URL}/api/pdf/ticket/proforma`,
  pedidoTicket: `${API_URL}/api/pdf/ticket/pedido`,
  movimientoCajaTicket: `${API_URL}/api/pdf/ticket/movimiento-caja`,
  cajaChicaTicket: `${API_URL}/api/pdf/ticket/movimiento-caja`,
  notaPagoTicket: `${API_URL}/api/pdf/ticket/nota-pago`,
  prestamoTicket: `${API_URL}/api/pdf/ticket/prestamo`,
  prestamoCajaChicaTicket: `${API_URL}/api/pdf/ticket/prestamo-caja-chica`,
  pagoCuotaPrestamoTicket: `${API_URL}/api/pdf/ticket/pago-cuota-prestamo`,
}

export const urlExcels = {
  reporteContableVentas: `${API_URL}/api/excel/accounting-sales-report`,
  reporteContableNotasCredito: `${API_URL}/api/excel/accounting-credit-notes-report`,
}

export const urlXmls = {
  xmlSunat: `${API_URL}/api/xml/xml-sunat`,
  cdrSunat: `${API_URL}/api/xml/cdr-sunat`,
}